import { formatDistance, parseISO } from 'date-fns'

import type { IsoDate } from '../types/general'
import type { TaskOverview } from '../hooks/tasks/queries'

type Props = {
  completedAt: IsoDate | null
  due: IsoDate | null
}

function getDueString(task: Props) {
  if (task.completedAt) {
    return 'COMPLETED'
  }
  return task.due
    ? formatDistance(parseISO(task.due.iso), new Date(), {
        addSuffix: true,
      }).toUpperCase()
    : 'NO DUE DATE'
}

function getUserTasks(task: TaskOverview, stylistId: string) {
  if (task.className !== 'Alteration') return task.user.objectId === stylistId
  const { user, userSale, users } = task

  return (
    user.objectId === stylistId ||
    userSale?.objectId === stylistId ||
    users?.some((u) => u.objectId === stylistId)
  )
}

export { getDueString, getUserTasks }
